import React from 'react';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

const Logo: React.FC = () => {
  return (
    <Link to="/">
      <StaticImage
        src="../assets/images/logo-yellow.svg"
        alt="Scripted by Kat Logo"
        loading="eager"
        placeholder="none"
        width={160}
      />
    </Link>
  );
};

export default Logo;
